import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CMSSessionService {
  public token: string;
  public settingsToken: string;

  constructor() {}

  setToken(token: string) {
    this.token = token;
  }

  getToken() {
    return this.token;
  }

  setSettingsToken(token: string) {
    this.settingsToken = token;
  }

  getSettingsToken() {
    return this.settingsToken;
  }
}
